/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import {login,logout,valid,modifyPassword} from "./ajax";
import unit from "./ajax-unit";
import materialType from "./ajax-material-type";
import shop from "./ajax-shop";
import distributionCenter from "./ajax-distribution-center";
import common from "./ajax-common";
import bom from "./ajax-bom";
import kitchen from "./ajax-kitchen"
import material from "./ajax-material"
import priceManage from "./ajax-price-manage"
import supplier from "./ajax-supplier"
import staff from "./ajax-staff"
import role from "./ajax-role"
import printTemplate from "./ajax-print-template"
import merchant from "./ajax-merchant"
import brand from "./ajax-brand"
import log from "./ajax-log"

const ajax = {
  login,
  logout,
  valid,
  modifyPassword,
  unit,
  materialType,
  shop,
  distributionCenter,
  common,
  bom,
  kitchen,
  material,
  priceManage,
  supplier,
  staff,
  role,
  printTemplate,
  merchant,
  brand,
  log
}

export default ajax



// WEBPACK FOOTER //
// ./src/assets/ajax/index.js